import { motion } from "framer-motion";

const SectionHeading = ({ eyebrow, title, description }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    className="text-center max-w-3xl mx-auto mb-16"
  >
    {eyebrow && (
      <span className="font-display text-xs tracking-[0.3em] uppercase text-primary mb-3 block">
        {eyebrow}
      </span>
    )}
    <h2 className="text-3xl md:text-5xl font-bold mb-4 glow-text">{title}</h2>
    {description && <p className="text-muted-foreground text-lg leading-relaxed">{description}</p>}
  </motion.div>
);

export default SectionHeading;
